import {
  PathwayScenarioOutletContext,
  Intervention,
  PathwayIntervention,
} from '@/types';
import { Link, useOutletContext, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useTheme } from 'styled-components';
import {
  UtilityButton,
  Separator,
  Container,
  Frame,
  Content,
  Header,
  Toolbar,
  ToolbarGroup,
  ToolbarItem,
  H2,
} from '@kinesis/bungle';
import { useNewInterventionCategory } from '@/hooks/use-new-intervention-category';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useGetInventorySuggestionsQuery } from '@/api/inventories';
import { InterventionNew } from '@/components/intervention-new';
import { renderInterventionCategory } from '@/data/labels';
import { pathwayScenarioPath } from '@/links';

const PathwayScenarioInterventionsNew = () => {
  const { scenario, addIntervention } =
    useOutletContext<PathwayScenarioOutletContext>();
  const inventoryId = useInventoryId();
  const { data: suggestions } = useGetInventorySuggestionsQuery(inventoryId);
  const category = useNewInterventionCategory();
  const navigate = useNavigate();
  const theme = useTheme() as any;

  const onCreate = useCallback(
    (v: Intervention | PathwayIntervention) => {
      addIntervention(v as Intervention);
      navigate(pathwayScenarioPath(scenario.inventory, scenario.id));
    },
    [navigate, addIntervention, scenario],
  );

  return (
    <div
      style={{
        paddingLeft: 80,
        background: theme.color.monochrome2,
        height: '100%',
      }}
    >
      <Content padding='none' background='white' height='100%' borderLeft>
        <Container>
          <Header border>
            <Toolbar>
              <ToolbarGroup>
                <ToolbarItem>
                  <UtilityButton
                    as={Link}
                    to={pathwayScenarioPath(scenario.inventory, scenario.id)}
                    icon='arrow-right'
                    display='block'
                  />
                </ToolbarItem>
                <Separator />
                <ToolbarItem ellipsify>
                  <H2>{renderInterventionCategory(category)} intervention</H2>
                </ToolbarItem>
              </ToolbarGroup>
            </Toolbar>
          </Header>
          <Frame sizing='fill-container'>
            <InterventionNew
              category={category}
              onCreate={onCreate}
              suggestions={suggestions}
            />
          </Frame>
        </Container>
      </Content>
    </div>
  );
};

export { PathwayScenarioInterventionsNew };
